import { Button, Checkbox, Input, Select } from "antd";
import { useEffect, useState } from "react";
import SelectDropdownLgIcon from "../../../assets/icons/SelectDropdownLgIcon";
import useModal from "../../../hooks/useModal";
import ConfirmModal from "../../ui/ConfirmModal";

const { Option } = Select;

interface SelectEmployeeWithCheckboxProps {
  data?: {
    name: string;
    id: number;
    departmentId: number;
    employeeId?: string | null;
    alreadySet?: "Location" | "Remote" | "Wifi";
  }[];
  value?: number[];
  savedValue?: number[];
  onChange?: (value?: number[], isDuplicate?: boolean, isAll?: boolean) => void;
  departmentId?: number;
  type: "location_based" | "remote" | "ip_based" | "visit_remote_required";
  disabled?: boolean;
}

const typeMatch = {
  location_based: "Location",
  remote: "Remote",
  ip_based: "Wifi",
  visit_remote_required: "Visit restriction",
};

const SelectEmployeeWithCheckbox = ({
  data,
  value = [],
  savedValue,
  onChange,
  departmentId,
  type,
  disabled,
}: SelectEmployeeWithCheckboxProps) => {
  const [searchText, setSearchText] = useState("");
  const [isAllSelected, setIsAllSelected] = useState(false);
  const { open, handleClose, handleOpen } = useModal<
    { id: number; set: "Location" | "Remote" | "Wifi"; isMultiHide?: boolean },
    "CONFIRM"
  >();
  // const {
  //   open: openSelectAll,
  //   handleClose: handleSelectAllClose,
  //   handleOpen: handleSelectAllOpen,
  // } = useModal<any, "SELECT_ALL">();

  const handleSearch = (e: React.ChangeEvent<HTMLInputElement>) => {
    setSearchText(e.target.value);
  };

  const filteredData = data
    ?.filter((emp) => (departmentId ? emp?.departmentId === departmentId : emp))
    ?.filter((emp) =>
      searchText
        ? emp?.name?.toLowerCase()?.includes(searchText?.toLowerCase()) ||
          emp?.employeeId?.toLowerCase()?.includes(searchText?.toLowerCase())
        : emp
    );

  const handleSelectAll = (e: any) => {
    const allDataIds = filteredData?.map((emp) => emp.id);
    const newValue = e.target.checked ? allDataIds : [];
    onChange?.(newValue, true, true);
    setIsAllSelected(e.target.checked);
  };

  const handleCheckboxChange = (id: number, isDuplicate?: boolean) => {
    const newValue = value?.includes(id)
      ? value?.filter((empId) => empId !== id)
      : [...value, id];
    onChange?.(newValue, isDuplicate);
  };

  useEffect(() => {
    if (
      areArraysEqual(
        value,
        filteredData?.map((el) => el?.id)
      )
    ) {
      setIsAllSelected(true);
    } else {
      setIsAllSelected(false);
    }
  }, [filteredData, value]);

  function areArraysEqual(array1?: number[], array2?: number[]): boolean {
    if (array1?.length !== array2?.length) return false;

    const sortedArray1 = array1 ? [...array1].sort((a, b) => a - b) : [];
    const sortedArray2 = array2 ? [...array2].sort((a, b) => a - b) : [];

    return sortedArray2?.every((value, index) => value === sortedArray1[index]);
  }

  return (
    <>
      {open?.type === "CONFIRM" ? (
        <ConfirmModal
          open={open?.open}
          handleClose={handleClose}
          handleOk={() => {
            handleCheckboxChange(open?.data?.id as number, false);
            handleClose();
          }}
          confirmTitle={`Already set ${open?.data?.set}`}
          questionText="Are sure to change attendance type?"
          okText="Confirm"
          footer={[
            <Button
              key="back"
              className="normal-button"
              onClick={() => handleClose()}
            >
              Cancel
            </Button>,
            // TODO: Hide condition as per new requirement
            // open?.data?.isMultiHide ? undefined : (
            //   <Button
            //     key="secondary"
            //     className="outline-button-primary"
            //     onClick={() => {
            //       handleCheckboxChange(open?.data?.id as number, true);
            //       handleClose();
            //     }}
            //   >
            //     Multi type attendance
            //   </Button>
            // ),
            <Button
              key="submit"
              type="primary"
              onClick={() => {
                handleCheckboxChange(open?.data?.id as number, false);
                handleClose();
              }}
            >
              Submit
            </Button>,
          ]}
        />
      ) : null}

      {/* {openSelectAll?.type === "SELECT_ALL" ? (
        <ConfirmModal
          open={openSelectAll?.open}
          handleClose={handleSelectAllClose}
          handleOk={() => {
            handleSelectAll(openSelectAll?.data);
            handleSelectAllClose();
          }}
          confirmTitle="Select All"
          questionText="Are sure to select all?"
          okText="Confirm"
          footer={[
            <Button
              key="back"
              className="normal-button"
              onClick={() => handleSelectAllClose()}
            >
              Cancel
            </Button>,
            openSelectAll?.data?.isMultiHide ? undefined : (
              <Button
                key="secondary"
                className="outline-button-primary"
                onClick={() => {
                  handleSelectAll(openSelectAll?.data, true);
                  handleSelectAllClose();
                }}
              >
                Multi type attendance
              </Button>
            ),
            <Button
              key="submit"
              type="primary"
              onClick={() => {
                handleSelectAll(openSelectAll?.data);
                handleSelectAllClose();
              }}
            >
              Submit
            </Button>,
          ]}
        />
      ) : null} */}

      <div className="flex flex-col flex-1">
      <Select
        placeholder="Select"
        value={value}
        showSearch={false}
        mode="tags"
        className="flex-1"
        disabled={disabled}
        dropdownRender={() => (
          <div className="p-2">
            <Checkbox
              onChange={(e) => {
                // handleSelectAllOpen({ data: e, type: "SELECT_ALL" })
                handleSelectAll(e);
              }}
              checked={filteredData?.length ? isAllSelected : false}
              className="text-body text-sm font-medium mb-2.5"
              disabled={!filteredData?.length}
            >
              {isAllSelected && filteredData?.length ? "Deselect " : "Select "}
              all
            </Checkbox>
            <Input placeholder="Search" onChange={handleSearch} />
            <div className="max-h-40 overflow-y-auto mt-1">
              {filteredData?.map((el) => {
                return (
                  <div key={el.id}>
                    <Checkbox
                      className="text-body text-sm font-medium mt-1.5"
                      checked={value?.includes(el?.id)}
                      onChange={(e) => {
                        const findData = data?.find(
                          (item) => item?.id === el?.id
                        );

                        // console.log(findData?.alreadySet, typeMatch[type]);

                        findData?.alreadySet &&
                        typeMatch[type] !== findData?.alreadySet &&
                        e?.target.checked
                          ? handleOpen({
                              type: "CONFIRM",
                              data: {
                                id: el?.id,
                                set: findData?.alreadySet,
                                isMultiHide:
                                  (findData?.alreadySet === "Location" &&
                                    typeMatch[type] === "Wifi") ||
                                  (findData?.alreadySet === "Wifi" &&
                                    typeMatch[type] === "Location"),
                              },
                            })
                          : handleCheckboxChange(el.id);
                      }}
                    >
                      {`${el.name || el?.id} ${
                        el?.employeeId ? `(${el?.employeeId})` : `(ID-)`
                      }`}
                    </Checkbox>
                  </div>
                );
              })}
            </div>
          </div>
        )}
        tagRender={({ label }) => (
          <div className=" bg-[#f0f0f0] rounded-md text-body mr-1 px-2 py-[5px]">
            {label}
          </div>
        )}
        maxTagCount={2}
        maxTagPlaceholder={(val) => `+ ${val?.length}`}
        suffixIcon={<SelectDropdownLgIcon />}
        style={{ minWidth: 300, maxWidth: "fit-content" }}
      >
        {value?.map((empId) => {
          const el = data?.find((emp) => emp.id === empId);
          // console.log(el);
          return (
            <Option key={empId} value={empId}>
              {el?.name}
            </Option>
          );
        })}
      </Select>
      {savedValue && !areArraysEqual(value, savedValue) && (
        <span className="text-sm text-body mt-1">Unsaved selection — {value.length} selected</span>
      )}
      </div>
    </>
  );
};

export default SelectEmployeeWithCheckbox;
